import { render, staticRenderFns } from "./card-structure.vue?vue&type=template&id=2cc36119&scoped=true&"
import script from "./card-structure.vue?vue&type=script&lang=js&"
export * from "./card-structure.vue?vue&type=script&lang=js&"
import style0 from "./card-structure.vue?vue&type=style&index=0&id=2cc36119&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc36119",
  null
  
)

export default component.exports